import { FC } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { ContentFunnel } from '../../types/activityDashboard';

interface Props {
    funnel: ContentFunnel;
}

const Stage: FC<{ label: string; value: number; rate?: number }> = ({ label, value, rate }) => (
    <Box sx={{ textAlign: 'center', minWidth: 96 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
            {label}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#2563eb' }}>
            {value.toLocaleString()}
        </Typography>
        {rate != null && (
            <Typography variant="caption" color="text.secondary">
                전환 {rate.toFixed(1)}%
            </Typography>
        )}
    </Box>
);

export const ContentFunnelCard: FC<Props> = ({ funnel }) => (
    <Card sx={{ height: '100%' }}>
        <CardContent sx={{ p: 2.5 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2 }}>
                콘텐츠 전환 퍼널 (생성 단어장 기준)
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', gap: 1, flexWrap: 'wrap' }}>
                <Stage label="생성" value={funnel.created} />
                <ArrowForward sx={{ color: 'text.disabled' }} />
                <Stage label="학습 착수" value={funnel.started} rate={funnel.startedRate} />
                <ArrowForward sx={{ color: 'text.disabled' }} />
                <Stage label="완료" value={funnel.completed} rate={funnel.completedRate} />
            </Box>
        </CardContent>
    </Card>
);
